import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { useAuth } from '@/core/auth/AuthContext';
import { toast } from 'sonner';
import { RequestsDetailService } from '../services/RequestsDetail.service';

export function useRequestsDetail() {
  const { id = '' } = useParams();
  const queryClient = useQueryClient();
  const { profile } = useAuth();
  const userId = profile?.id || '';
  const companyId = profile?.company_id || '';

  const query = useQuery({
    queryKey: ['inventory', 'requests', 'detail', id, userId],
    queryFn: () => RequestsDetailService.getRequest(id, userId, companyId),
    enabled: !!id && !!userId && !!companyId,
  });

  const approveMutation = useMutation({
    mutationFn: () => RequestsDetailService.approveRequest(id, userId, companyId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['inventory', 'requests'] });
      toast.success(' ph duyt yu cu');
    },
    onError: (error: any) => {
      toast.error(error.message || 'Khng th ph duyt');
    }
  });

  return {
    request: query.data,
    isLoading: query.isLoading,
    isApproving: approveMutation.isPending,
    approve: () => approveMutation.mutate(),
  };
}
